module.exports = __webpack_public_path__ + "img/tip-break.f318e523.gif";